import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import VideoRecap from "@/components/VideoRecap";
import RundenCounter from "@/components/RundenCounter";
import EllaStory from "@/components/EllaStory";
import RettInfo from "@/components/RettInfo";
import ResearchHope from "@/components/ResearchHope";
import EventInfo from "@/components/EventInfo";
import HowToHelp from "@/components/HowToHelp";
import DonationInfo from "@/components/DonationInfo";
import InstagramFeed from "@/components/InstagramFeed";
import Sponsors from "@/components/Sponsors";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Navigation />
      <HeroSection />
      <VideoRecap />
      <RundenCounter />
      <EllaStory />
      <RettInfo />
      <ResearchHope />
      <EventInfo />
      <HowToHelp />
      <DonationInfo />
      <InstagramFeed />
      <Sponsors />
      <Footer />
    </div>
  );
}
